import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { ConfirmDialog } from '../../../../../common/views/modals/confirmDialog/ConfirmDialog';
import { reelsPlanMessages } from './reelsPlanMessages';

interface EndReelsPlanDialogProps {
  isOpen: boolean;
  /** The drafts and the failed posts of the plan: they are deleted. */
  drafts: number;
  /** The scheduled and "needs you" posts of the plan: they are canceled. */
  scheduled: number;
  /** The reels of the plan: they stay in Posts. */
  reels: number;
  isBusy: boolean;
  /** The sentence of a failed "End the plan". */
  error?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The "End the plan" confirm (design rollout-plan f4): it names what the end deletes and cancels.
 * A post that went out stays, the reels stay in Posts, and no credit comes back. With no draft and
 * no scheduled post the text is short.
 */
const EndReelsPlanDialogComponent: React.FC<EndReelsPlanDialogProps> = ({
  isOpen,
  drafts,
  scheduled,
  reels,
  isBusy,
  error,
  onConfirm,
  onCancel,
}) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="neutral"
      title={intl.formatMessage(reelsPlanMessages.endTitle)}
      description={
        drafts + scheduled === 0
          ? intl.formatMessage(reelsPlanMessages.endBodyEmpty)
          : intl.formatMessage(reelsPlanMessages.endBody, { drafts, scheduled, reels })
      }
      confirmLabel={intl.formatMessage(reelsPlanMessages.endPlan)}
      cancelLabel={intl.formatMessage(reelsPlanMessages.endKeep)}
      isBusy={isBusy}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
      testId="end-reels-plan"
    />
  );
};

export const EndReelsPlanDialog = TypedMemo(EndReelsPlanDialogComponent);
